module.exports = {
  filter: (filter) => {
    if (typeof filter != "string") return filter;
    return filter.replace(/\</gi, "&lt;");
  },
}

// console.log("module.exports.filter():", module.exports.filter("<asdf> <asdf></asdf> </asdf>"));